import SingleSelectionOpenEntryItem
  from "components/pool-details/entries/single-selection-entry-list/single-selection-open-entry-item";
import { useAppSelector } from "state/hooks";
import { getGroupState } from "state/slices/group-slice";
import { Entry } from "interfaces/entry";
import { Dispatch, SetStateAction, useState } from "react";
import { postRequest } from "utils/httpClient";
import AreYouSureForm from "./are-you-sure-form";
import SingleSelectionLiveEntryItem from "./live-enrty-item";
import { getConfirmContestantPath } from "utils/backend-path-builders";
import {getIntegratedAppState} from "../../../state/slices/integrated-app-slice";

interface Props {
  entries: Entry[];
  poolId: string;
  confirmedContestantId: string;
  setConfirmedContestantId: Dispatch<SetStateAction<string>>;
}

const Representer = ({
                       entries,
                       poolId,
                       setConfirmedContestantId,
                       confirmedContestantId,
                     }: Props) => {
  const [selectedContestantId, setSelectedContestantId] = useState("");
  const [loading, setLoading] = useState(false);
  const groupId = useAppSelector(getGroupState).id;
  const [areYouSureFormHeight, setAreYouSureFormHeight] = useState(70);
  const totalSeedDistribution = entries.reduce((acc, item) => {
    return acc + item.seed_distribution;
  }, 0);
  const integratedAppState = useAppSelector(getIntegratedAppState);

  const confirmResult = (entry: Entry) => {
    setLoading(true);
    const contestantId = entry.contestant_id;
    postRequest(getConfirmContestantPath(integratedAppState.isIntegratedApp), {
      body: {
        group_id: groupId,
        contestant_id: contestantId,
        pool_id: poolId,
        status: "selected",
      },
    })
      .then((data) => {
        setConfirmedContestantId(contestantId);
        setSelectedContestantId("");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {entries.map((entry) => {
        const isSelected = selectedContestantId === entry.contestant_id;
        const isConfirmed = confirmedContestantId === entry.contestant_id;
        const projectedWin =
          entry.seed_distribution / totalSeedDistribution || 0;

        return (
          <div key={entry.contestant_id} style={{ position: "relative" }}>
            {confirmedContestantId === "" ? (
              <SingleSelectionOpenEntryItem
                item={entry}
                selectBet={() => setSelectedContestantId(entry.contestant_id)}
                setHeight={setAreYouSureFormHeight}
                projectedWin={projectedWin}
              />
            ) : (
              <SingleSelectionLiveEntryItem
                item={entry}
                confirmed={isConfirmed}
                hasActionButton={false}
                projectedWin={projectedWin}
              />
            )}
            {isSelected && (
              <AreYouSureForm
                isLoading={loading}
                onConfirm={confirmResult}
                entry={entry}
                height={areYouSureFormHeight}
              />
            )}
          </div>
        );
      })}
    </>
  );
};

export default Representer;
